import { Radar, Globe, Shield } from 'lucide-react';

const ACTORS = [
  { name: 'APT41', country: 'China', ttps: 'T1566, T1190, T1059', lastActivity: '2026-05-10', risk: 'High' },
  { name: 'Lazarus Group', country: 'North Korea', ttps: 'T1566.001, T1203, T1055', lastActivity: '2026-05-08', risk: 'Critical' },
  { name: 'OceanLotus', country: 'Vietnam', ttps: 'T1566, T1059.001, T1082', lastActivity: '2026-04-28', risk: 'Medium' },
  { name: 'APT29', country: 'Russia', ttps: 'T1190, T1059, T1505', lastActivity: '2026-05-11', risk: 'High' },
  { name: 'DragonFish', country: 'Malaysia', ttps: 'T1566, T1204.002, T1059', lastActivity: '2026-05-09', risk: 'Medium' },
  { name: 'Charming Kitten', country: 'Iran', ttps: 'T1566, T1078, T1059', lastActivity: '2026-04-30', risk: 'High' },
];

const RISK_STYLES = {
  Critical: 'bg-red-500/20 text-red-400 border-red-500/30',
  High: 'bg-red-500/20 text-red-400 border-red-500/30',
  Medium: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  Low: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
};

const MyCERTInsights = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">Local Insights (MyCERT)</h1>
      <p className="text-sm text-gray-500 mt-1">
        Malaysian-specific threat actor and campaign data · PRD: INTEL-01 (Section 7.8)
      </p>
    </div>

    <div className="bg-dark-800 border border-dark-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Radar className="w-5 h-5 text-orange-400" />
          <h2 className="text-lg font-semibold text-white">Threat Actors</h2>
        </div>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-600/20 text-orange-400 border border-orange-600/30">
          Coming Soon
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 uppercase text-xs border-b border-gray-700/50">
              <th className="text-left py-3 pr-4 font-medium">Actor Name</th>
              <th className="text-left py-3 pr-4 font-medium">Country</th>
              <th className="text-left py-3 pr-4 font-medium">MITRE TTPs</th>
              <th className="text-left py-3 pr-4 font-medium">Last Activity</th>
              <th className="text-left py-3 font-medium">Risk Level</th>
            </tr>
          </thead>
          <tbody className="text-gray-400">
            {ACTORS.map((actor, i) => (
              <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/30 transition-colors">
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-2">
                    <Shield className="w-3.5 h-3.5 text-gray-600" />
                    <span className="text-white font-medium">{actor.name}</span>
                  </div>
                </td>
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-1.5">
                    <Globe className="w-3 h-3 text-gray-600" />
                    <span>{actor.country}</span>
                  </div>
                </td>
                <td className="py-3 pr-4 font-mono text-xs">{actor.ttps}</td>
                <td className="py-3 pr-4 font-mono text-xs text-gray-500">{actor.lastActivity}</td>
                <td className="py-3">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${RISK_STYLES[actor.risk]}`}>
                    {actor.risk}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default MyCERTInsights;
